import { Link } from '@/components/shared/Link';
import { ArrowRight } from 'lucide-react';
import { RichText } from '@/components/shared/RichText';

interface JobCardProps {
  title: string;
  description: string;
  slug: string;
}

export function JobCard({ title, description, slug }: JobCardProps) {
  return (
    <div className="bg-white rounded-xl border border-light p-6 hover:shadow-lg transition-shadow duration-300 group h-full flex flex-col justify-between">
      <div>
        <h3
          className="text-[18px] font-bold text-navy mb-3 group-hover:text-primary transition-colors font-heading"
        >
          {title}
        </h3>
        <RichText
          html={description || ''}
          className="text-[14px] text-gray-500 leading-relaxed mb-4 font-sans [&_p]:mb-2 line-clamp-3"
        />
      </div>
      <Link
        href={`/career/${slug}`}
        className="inline-flex items-center gap-2 text-[14px] font-semibold text-primary hover:text-navy transition-colors font-sans"
      >
        Read More
        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
      </Link>
    </div>
  );
}
